var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Environment_Icon",
    "data-name": "Environment Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(0 32) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Environment_Icon-2",
    "data-name": "Environment Icon",
    d: "M26.793,22.656c-2.988-.462-3.213-.675-3.213-.675.9-4.269-1.292-8.717-4.4-11.285C15.035,7.281,8.741,9.761,3.837,4.569,2.694,3.357,3.358,18.156,9.5,23.763a10.792,10.792,0,0,0,11.221,2.169,6.424,6.424,0,0,0,2.233-1.956,16.931,16.931,0,0,0,3.577.819C27.37,24.9,27.8,22.811,26.793,22.656Zm-5.3.427c-4.483-1.344-8.383-4.673-10.91-7.281a.235.235,0,0,1,.317-.346,35.084,35.084,0,0,0,11.152,6.225A2.151,2.151,0,0,1,21.5,23.083Z",
    transform: "translate(0.624 0.501)",
    fill: "#1aaa30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentIcon);
export default __webpack_public_path__ + "static/media/environmentIcon.fd56eba74951d8af95998d8a1ec743fd.svg";
export { ForwardRef as ReactComponent };